import React, { useState } from 'react'
import HelpDeskBene from './HelpDeskBene'
import EligibilityDetails from '../Eligibility/components/responseEligbility/EligibilityDetails'

function HelpDesk () {
  const [chiReqRecord, setChiReqRecord] = useState(null)
  const [systemType, setSystemType] = useState(null)
  const [eligibilityId, setEligibilityId] = useState(null)
  return (
    <div>
      <HelpDeskBene
        chiReqRecord={chiReqRecord}
        setChiReqRecord={setChiReqRecord}
        systemType={systemType}
        setSystemType={setSystemType}
        eligibilityId={eligibilityId}
        setEligibilityId={setEligibilityId}
      />
      {eligibilityId && (
        <EligibilityDetails helpDeskItem={{ transaction_id: eligibilityId }} />
      )}
    </div>
  )
}

export default HelpDesk
